<div class="widgets-container grid">
  <ui-widget-box
    *ngFor="let item of widgets"
    [item]="item"
    [ngClass]="item.size"
    [widgetStyle]="widgetStyle"
  ></ui-widget-box>
</div>
